import { createContext, useContext, useEffect, useState, type ReactNode } from 'react';

// Single app-wide 1-second tick (port of the prototype's app.jsx interval).
// Drives running-timer counters, day/week totals, and Team Activeness — with
// zero network cost. Data freshness is handled separately by React Query polling.
const NowContext = createContext<number>(Date.now());

export function NowProvider({ children }: { children: ReactNode }) {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, []);
  return <NowContext.Provider value={now}>{children}</NowContext.Provider>;
}

export const useNow = (): number => useContext(NowContext);
